module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"companyTitle":"Take a peek at your new company","addAnotherCompany":"Add another company","viewCompanyRecordButton":"View company record"}}')
  delete Component.options._Ctor
}
